module.exports = __webpack_public_path__ + "img/engineering.cb4e70ae.png";